const state ={
  currentNew:{},
  desc:'爱好'
}
const mutations = {}
const actions = {}
const getters={}
export default {
  state,
  mutations,
  actions,
  getters
}